/** Sentinel option value for the calendar auditor filter (sent as include_unassigned_auditor). */
export const CALENDAR_UNASSIGNED_AUDITOR = "Unassigned";
